import { Pages } from "./types";

export const enum AnalyticsPageOrganization {
  Organization = "Organization",
  OrganizationApiKeys = "OrganizationApiKeys",
  OrganizationApiKeyRoles = "OrganizationApiKeyRoles",
  OrganizationBilling = "OrganizationBilling",
  OrganizationBillingInvoiceForm = "OrganizationBillingInvoiceForm",
  OrganizationBillingUpgradeForm = "OrganizationBillingUpgradeForm",
  OrganizationIdpGroupMapping = "OrganizationIdpGroupMapping",
  OrganizationIdpGroupRoles = "OrganizationIdpGroupRoles",
  OrganizationIdpGroupUsers = "OrganizationIdpGroupUsers",
  OrganizationIntegrations = "OrganizationIntegrations",
  OrganizationLoginPolicies = "OrganizationLoginPolicies",
  OrganizationLoginPoliciesList = "OrganizationLoginPoliciesList",
  OrganizationLoginPolicyCreate = "OrganizationLoginPolicyCreate",
  OrganizationLoginPolicyDetails = "OrganizationLoginPolicyDetails",
  OrganizationLimits = "OrganizationLimits",
  OrganizationSpaces = "OrganizationSpaces",
  OrganizationManagementStrategy = "OrganizationManagementStrategy",
  OrganizationOIDC = "OrganizationOIDC",
  OrganizationRoles = "OrganizationRoles",
  OrganizationRole = "OrganizationRole",
  OrganizationRoleUsedBy = "OrganizationRoleUsedBy",
  OrganizationRoleCreate = "OrganizationRoleCreate",
  OrganizationRolePermissions = "OrganizationRolePermissions",
  OrganizationSlackAccess = "OrganizationSlackAccess",
  OrganizationSAML = "OrganizationSAML",
  OrganizationSecurityEmail = "OrganizationSecurityEmail",
  OrganizationSessions = "OrganizationSessions",
  OrganizationSSO = "OrganizationSSO",
  OrganizationUsage = "OrganizationUsage",
  OrganizationUsageChart = "OrganizationUsageChart",
  OrganizationUsers = "OrganizationUsers",
  OrganizationUserRoles = "OrganizationUserRoles",
  OrganizationUserIntegrations = "OrganizationUserIntegrations",
  OrganizationUserIdpGroups = "OrganizationUserIdpGroups",
  OrganizationAi = "OrganizationAi",
  OrganizationRuntimeSecurity = "OrganizationRuntimeSecurity",
}

const organizationSettings = "Organization settings";
const sso = "SSO";
const billing = "Billing";
const usage = "Usage";

export const pagesOrganization: Pages<AnalyticsPageOrganization> = {
  [AnalyticsPageOrganization.Organization]: [organizationSettings],
  [AnalyticsPageOrganization.OrganizationIdpGroupMapping]: [
    organizationSettings,
    "IdP group mapping",
  ],
  [AnalyticsPageOrganization.OrganizationIntegrations]: [organizationSettings, "Integrations"],
  [AnalyticsPageOrganization.OrganizationLoginPolicies]: [
    organizationSettings,
    "Login Policies List",
  ],
  [AnalyticsPageOrganization.OrganizationManagementStrategy]: [
    organizationSettings,
    "Management strategy",
  ],
  [AnalyticsPageOrganization.OrganizationSlackAccess]: [
    organizationSettings,
    "Integrations",
    "Manage Slack Access",
  ],
  [AnalyticsPageOrganization.OrganizationUsage]: [organizationSettings, usage],
  [AnalyticsPageOrganization.OrganizationUsageChart]: [organizationSettings, usage, "Usage chart"],
  [AnalyticsPageOrganization.OrganizationUsers]: [organizationSettings, "Users"],
  [AnalyticsPageOrganization.OrganizationUserRoles]: [organizationSettings, "User", "Roles"],
  [AnalyticsPageOrganization.OrganizationUserIntegrations]: [
    organizationSettings,
    "User",
    "Integrations",
  ],
  [AnalyticsPageOrganization.OrganizationUserIdpGroups]: [
    organizationSettings,
    "User",
    "IdP groups",
  ],
  [AnalyticsPageOrganization.OrganizationBilling]: [organizationSettings, billing],
  [AnalyticsPageOrganization.OrganizationIdpGroupRoles]: [
    organizationSettings,
    "IdP group",
    "Roles",
  ],
  [AnalyticsPageOrganization.OrganizationIdpGroupUsers]: [
    organizationSettings,
    "IdP group",
    "Users",
  ],
  [AnalyticsPageOrganization.OrganizationBillingInvoiceForm]: [
    organizationSettings,
    billing,
    "Invoice Form",
  ],
  [AnalyticsPageOrganization.OrganizationBillingUpgradeForm]: [
    organizationSettings,
    billing,
    "Upgrade Form",
  ],
  [AnalyticsPageOrganization.OrganizationOIDC]: [organizationSettings, sso, "OIDC"],
  [AnalyticsPageOrganization.OrganizationRole]: [organizationSettings, "Role"],
  [AnalyticsPageOrganization.OrganizationRoleUsedBy]: [organizationSettings, "Role", "Used by"],
  [AnalyticsPageOrganization.OrganizationRoles]: [organizationSettings, "Roles"],
  [AnalyticsPageOrganization.OrganizationRoleCreate]: [
    organizationSettings,
    "Roles",
    "Create role",
  ],
  [AnalyticsPageOrganization.OrganizationRolePermissions]: [
    organizationSettings,
    "Role",
    "Permissions",
  ],
  [AnalyticsPageOrganization.OrganizationSSO]: [organizationSettings, sso],
  [AnalyticsPageOrganization.OrganizationSAML]: [organizationSettings, sso, "SAML"],
  [AnalyticsPageOrganization.OrganizationSecurityEmail]: [organizationSettings, "Security email"],
  [AnalyticsPageOrganization.OrganizationSessions]: [organizationSettings, "Sessions"],
  [AnalyticsPageOrganization.OrganizationRuntimeSecurity]: [
    organizationSettings,
    "Runtime Security",
  ],
  [AnalyticsPageOrganization.OrganizationApiKeys]: [organizationSettings, "API keys"],
  [AnalyticsPageOrganization.OrganizationApiKeyRoles]: [organizationSettings, "API key", "Roles"],
  [AnalyticsPageOrganization.OrganizationLimits]: [organizationSettings, "Limits"],
  [AnalyticsPageOrganization.OrganizationLoginPolicyDetails]: [
    organizationSettings,
    "Login Policy Details",
  ],
  [AnalyticsPageOrganization.OrganizationLoginPolicyCreate]: [
    organizationSettings,
    "New Login Policy",
  ],
  [AnalyticsPageOrganization.OrganizationLoginPoliciesList]: [
    organizationSettings,
    "Login Policies List",
  ],
  [AnalyticsPageOrganization.OrganizationAi]: [organizationSettings, "AI"],
  [AnalyticsPageOrganization.OrganizationSpaces]: [organizationSettings, "Spaces"],
};
